import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { TermsAndConditionsConfigService } from "./terms-and-conditions.config";
import { TermsAndConditionsVersion } from "./terms-and-conditions.model";

@Injectable({
	providedIn: "root",
})
export class TermsAndConditionsService {
	constructor(
		private httpClient: CoreHttpClient,
		private config: TermsAndConditionsConfigService
	) {}

	getHistory(): Observable<TermsAndConditionsVersion[]> {
		return this.httpClient.get<TermsAndConditionsVersion[]>({ url: this.config.getHistoryEndpoint() });
	}

	getLatestVersion(): Observable<TermsAndConditionsVersion> {
		return this.httpClient.get<TermsAndConditionsVersion>({ url: this.config.getLatestVersionEndpoint() });
	}

	getLatestAcceptedContent(): Observable<string> {
		return this.httpClient.get<string>({ url: this.config.latestAcceptedContentUrl() });
	}

	downloadPdfFile(base64String: string, fileName?: string): void {
		const linkSource = `data:application/pdf;base64,${base64String}`;
		const downloadLink = document.createElement("a");
		const file = fileName ?? `${new Date().toISOString()}-document.pdf`;

		downloadLink.href = linkSource;
		downloadLink.download = file;
		downloadLink.click();
		downloadLink.remove();
	}
}
